/**
 * NOTE:
 * 公式ローダーは使わず script タグを手動挿入して読み込む。
 * `google.maps.marker.AdvancedMarkerElement` を利用する。
 */

let googleMapsPromise;

/**
 * Google Maps API を1回だけロード
 */
function loadGoogleMaps(apiKey) {
  if (googleMapsPromise) return googleMapsPromise;

  googleMapsPromise = new Promise((resolve, reject) => {
    if (window.google?.maps?.Map) {
      resolve(window.google.maps);
      return;
    }

    const callbackName = "__googleMapsInitCallback";

    // Google 推奨の loading=async + callback 方式で読み込む
    window[callbackName] = () => {
      if (window.google?.maps) {
        resolve(window.google.maps);
      } else {
        reject(new Error("Google Maps API failed to initialize"));
      }
      // 後片付け
      try {
        delete window[callbackName];
      } catch {
        window[callbackName] = undefined;
      }
    };

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
      apiKey
    )}&v=quarterly&libraries=marker&loading=async&callback=${callbackName}`;
    script.async = true;
    script.defer = true;
    script.onerror = reject;

    document.head.appendChild(script);
  });

  return googleMapsPromise;
}

/**
 * 地図描画
 */
async function renderMap(el) {
  const center = { lat: 36.390832, lng: 139.069735 };
  const mapId = el.dataset.googleMapsMapId;
  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

  const mapOptions = {
    center,
    zoom: 17,
  };

  if (mapId) {
    mapOptions.mapId = mapId;
  }

  const map = new google.maps.Map(el, mapOptions);
  const pin = new PinElement();
  pin.style.cursor = "pointer";

  const marker = new AdvancedMarkerElement({
    map,
    position: center,
    title: "〒371-0023 群馬県前橋市本町2丁目1-10 天元ビル301",
    content: pin,
  });

  const info = new google.maps.InfoWindow({
    content: `
      <strong>天元ビル 301</strong><br>
      〒371-0023<br>
      群馬県前橋市本町2丁目1-10
    `,
  });

  const openInfoWindow = () => {
    info.open({ map, anchor: marker });
  };

  marker.addEventListener("gmp-click", openInfoWindow);
  pin.addEventListener("mouseenter", openInfoWindow);
}

/**
 * 初期化
 */
function boot() {
  const el = document.getElementById("map");

  if (!el || el.dataset.mapInitialized) return;

  el.dataset.mapInitialized = "true";

  const apiKey = el.dataset.googleMapsApiKey;
  if (!apiKey) {
    console.error("map.js: GOOGLE_MAPS_API_KEY is missing");
    return;
  }

  loadGoogleMaps(apiKey)
    .then(() => renderMap(el))
    .catch((e) => console.error("map.js: init failed", e));
}

document.addEventListener("DOMContentLoaded", boot);
document.addEventListener("turbo:load", boot);
